export default __webpack_public_path__ + "static/media/file.4e02d02c.svg";